import { render } from "./BaseTableForms.vue?vue&type=template&id=4845dc38"
import script from "./BaseTableForms.vue?vue&type=script&lang=js"
export * from "./BaseTableForms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__